var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/~/core-js/library/modules/_shared-key.js
// module id = bLqF
// module chunks = 6